<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="arrangedInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <div>
            {{ arrangedInfo.guid }}
          </div>
          <div style="font-weight: bolder">
            {{ arrangedInfo.arrangedName }}
          </div>
        </div>
        <div>
          <el-button :size="$xUISize" @click="createClick" type="primary">
            创建采购单
          </el-button>
        </div>
      </el-card>
      <div>
        <x-tab v-model="tabName" :tabs="tabs" :query="tabParams" :params="tabParams" />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.arranged-detail {
  margin-top: 20px;
}
</style>

<script>
import arrangedFromPage from "./__arranged_create.vue";
import purchaseCreatePage from "./__arranged_purchase_create.vue";
import purchaseList from "./__arranged_purchase_list.vue";

export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.arrangedInfo) {
        return {};
      }
      return {
        arrangedGuid: this.arrangedInfo.guid,
        storehouseGuid: this.arrangedInfo.storehouseGuid,
        storeGuid: "",
      };
    },
    tabs() {
      if (!this.arrangedInfo) {
        return [];
      }
      let tabList = [
        {
          name: "arranged-item-list",
          label: "采购订单",
          component: purchaseList,
          interval: true,
        },
      ];
      return tabList;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      arrangedInfo: null,
      printLoading: false,
      cancelLoading: false,
      tabName: "",
    };
  },
  methods: {
    createClick() {
      this.$drawer.openDrawer({
        title: "创建采购单",
        refresh: this.getDetail,
        component: purchaseCreatePage,
        params: this.tabParams,
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.arrangedInfo = null;
      return this.requestApi("biz.warehouse.arranged.info.detail", {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
      })
        .then((resp) => {
          this.arrangedInfo = resp.data;
        })
        .catch((err) => {
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
};
</script>
